export enum AsqPeriod {
  Q1 = 0,
  Q2 = 1,
  Q3 = 2,
  Q4 = 3,
  Summer = 4,
  Winter = 5,
}
